import { all, fork, put, takeEvery } from "redux-saga/effects";
// import { useIntl } from 'react-intl';

import {

    // Housekeeping Management
    HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_BY_DATE,
    // HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_SUCCESS,
    HOUSEKEEPING_MANAGEMENT_CREATE_HOUSEKEEPING,
    HOUSEKEEPING_MANAGEMENT_UPDATE_HOUSEKEEPING,
    HOUSEKEEPING_MANAGEMENT_DELETE_HOUSEKEEPING,

    // HOUSEKEEPING_MANAGEMENT_LOAD_POSITION,
    // // HOUSEKEEPING_MANAGEMENT_LOAD_POSITION_SUCCESS,
    // HOUSEKEEPING_MANAGEMENT_CREATE_POSITION,
    // HOUSEKEEPING_MANAGEMENT_UPDATE_POSITION,
    // HOUSEKEEPING_MANAGEMENT_DELETE_POSITION,

    // HOUSEKEEPING_MANAGEMENT_LOAD_STAFF,
    // // HOUSEKEEPING_MANAGEMENT_LOAD_STAFF_SUCCESS,
    // HOUSEKEEPING_MANAGEMENT_CREATE_STAFF,
    // HOUSEKEEPING_MANAGEMENT_UPDATE_STAFF,
    // HOUSEKEEPING_MANAGEMENT_DELETE_STAFF,
    // END Housekeeping Management

} from "../actions";

import {
    // Housekeeping Management
    // settingGetHousekeepingByTime,
    housekeepingGetHousekeepingByTime,
    housekeepingAddHousekeeping,
    housekeepingUpdateHousekeeping,
    housekeepingDeleteHousekeeping,

    // settingGetPosition,
    // settingAddPosition,
    // settingUpdatePosition,
    // settingDeletePosition,

    // settingGetStaff,
    // settingCreateStaff,
    // settingUpdateStaff,
    // settingDeleteStaff,
    // END Housekeeping Management

} from "../../helpers/housekeeping-api";

import {
    // booking Management
    bookingGetCheckBookingTreatmentUsedByTimeInHousekeeping
    // END booking Management

} from "../../helpers/booking-api";

import {
    getHousekeepingByTime,
    getHousekeepingByTimeSuccess,
    // getPosition,
    // getPositionSuccess,
    // getStaff,
    // getStaffSuccess,
} from "./actions";

import { NotificationManager } from '../../components/common/react-notifications';


const PullNotificationManager = async (text) => {
    // eslint-disable-next-line no-return-await
    await NotificationManager.warning(text, 'Error', 3000, null, null, '');
}



// Housekeeping Management
function* housekeepingManagementLoadHousekeepingByTime({ payload, token }) {
    // const intl = useIntl();
    try {
        const dt = new Date();
        const currentDateTime = `${dt.getFullYear().toString().padStart(4, '0')}-${(dt.getMonth() + 1).toString().padStart(2, '0')}-${dt.getDate().toString().padStart(2, '0')}`
        const currentTime = `${dt.getFullYear().toString().padStart(4, '0')}-${(dt.getMonth() + 1).toString().padStart(2, '0')}-${dt.getDate().toString().padStart(2, '0')} ${dt.getHours().toString().padStart(2, '0')}:${dt.getMinutes().toString().padStart(2, '0')}:${dt.getSeconds().toString().padStart(2, '0')}`

        const dataRes = yield housekeepingGetHousekeepingByTime({ ...payload, currentTime }, token);
        if (dataRes.status === 'success') {

            const activityDate = `${dt.getFullYear()}/${(dt.getMonth() + 1).toString().padStart(2, "0")}/${(dt.getDate()).toString().padStart(2, "0")}`
            const dataResCheckBookingTreatmentUsedByTime = yield bookingGetCheckBookingTreatmentUsedByTimeInHousekeeping({ ...payload, activityDate }, token);
            if (dataResCheckBookingTreatmentUsedByTime.status === "success") {
                // let list = [];

                const listChcekBooking = dataResCheckBookingTreatmentUsedByTime.data.filter((item) => {

                    const currentStartTime = `${currentDateTime} ${item.start_time_treatment || "00:00"}:00`
                    const currentEndTime = `${currentDateTime} ${item.end_time_treatment || "00:00"}:00`

                    return currentStartTime <= currentTime && currentTime <= currentEndTime

                })

                const listBooking = listChcekBooking.map((item) => {

                    const currentStartTime = `${currentDateTime} ${item.start_time_treatment || "00:00"}:00`
                    const currentEndTime = `${currentDateTime} ${item.end_time_treatment || "00:00"}:00`

                    return {
                        ...item,
                        // no: index + 1,
                        id_housekeeping: `HK_${item.id_booking_customer_treatment}`,
                        // id_booking: item.booking_no,
                        status_housekeeping: (item.status === "BOOKED" || item.status === "CONFIRMED" || item.status === "CHECKEDIN") ? "Occupied" : item.status_clean_housekeeping ? "VacantClean" : "VacantDirty",
                        status_out_of_service: false,
                        description_out_of_service: "-",
                        start_time_used: currentStartTime,
                        end_time_used: currentEndTime,
                        // label: `${item.first_name} ${item.last_name}`,
                        // value: item.id_housekeeping,

                    }
                });

                // console.log(listBooking);

                let listChcekBookingDuplicated = []

                listBooking.map((itemBooking) => {

                    if (listChcekBookingDuplicated.length > 0) {

                        const chcekListBookingDuplicated = listChcekBookingDuplicated.find(el => {
                            return (el.id_booking_customer === itemBooking.id_booking_customer &&
                                el.id_booking === itemBooking.id_booking &&
                                el.id_bed === itemBooking.id_bed)
                        })

                        if (chcekListBookingDuplicated) {

                            listChcekBookingDuplicated = listChcekBookingDuplicated.map(el => {
                                let checkData = el

                                if (el.id_booking_customer === itemBooking.id_booking_customer &&
                                    el.id_booking === itemBooking.id_booking &&
                                    el.id_bed === itemBooking.id_bed) {
                                    checkData = {
                                        ...el,
                                        start_time_used: itemBooking.start_time_used < el.start_time_used ? itemBooking.start_time_used : el.start_time_used,
                                        end_time_used: itemBooking.end_time_used > el.end_time_used ? itemBooking.end_time_used : el.end_time_used,
                                        duplicatedBedData: [
                                            ...(el.duplicatedBedData || []),
                                            itemBooking,
                                        ],
                                    }
                                }

                                return checkData

                            })

                        } else {
                            listChcekBookingDuplicated = [
                                ...listChcekBookingDuplicated,
                                { ...itemBooking, duplicatedBedData: [itemBooking] },
                            ]
                        }

                    } else {
                        listChcekBookingDuplicated = [
                            ...listChcekBookingDuplicated,
                            { ...itemBooking, duplicatedBedData: [itemBooking] },
                        ]
                    }

                    return "listChcekBooking"
                })

                // console.log(listChcekBookingDuplicated);

                const list = [
                    ...(dataRes.data || []),
                    ...(listChcekBookingDuplicated || [])
                ]

                const checkList = list.map((item, index) => {
                    return {
                        ...item,
                        no: index + 1,
                    }
                })

                yield put(getHousekeepingByTimeSuccess(list, checkList));
            }
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* housekeepingManagementAddHousekeeping({ payload, token }) {
    try {
        const dataRes = yield housekeepingAddHousekeeping(payload, token);
        if (dataRes.status === 'success') {
            yield put(getHousekeepingByTime({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* housekeepingManagementUpdateHousekeeping({ payload, token }) {
    try {
        const dataRes = yield housekeepingUpdateHousekeeping(payload, token);
        if (dataRes.status === 'success') {
            yield put(getHousekeepingByTime({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ spa_id: payload.spa_id }, token));
            // yield put(getStaff({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* housekeepingManagementDeleteHousekeeping({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield housekeepingDeleteHousekeeping(items, token);
        if (dataRes.status === 'success') yield put(getHousekeepingByTime({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// function* housekeepingManagementLoadPosition({ payload, token }) {
//     try {
//         const dataRes = yield settingGetPosition(payload, token);
//         if (dataRes.status === 'success') {
//             const dataFilter = dataRes.data.filter(el => el.name_position === "Owner")
//             const allDataFilter = dataRes.data.filter(el => el.name_position !== "Owner")
//             const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
//             const list = checkDataFilter.map(item => (
//                 {
//                     ...item,
//                     label: item.name_position,
//                     value: item.id_position,
//                 }
//             ));
//             yield put(getPositionSuccess(checkDataFilter, list));
//         } else
//             if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     } catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* housekeepingManagementAddPosition({ payload, token }) {
//     try {
//         const dataRes = yield settingAddPosition(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getPosition({ spa_id: payload.spa_id }, token));
//         } else
//             if
//                 (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }

//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             }
//             else {
//                 yield PullNotificationManager(`${dataRes.msg}`);
//             }

//     } catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* housekeepingManagementUpdatePosition({ payload, token }) {
//     try {
//         const dataRes = yield settingUpdatePosition(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getPosition({ spa_id: payload.spa_id }, token));
//             yield put(getStaff({ spa_id: payload.spa_id }, token));
//             // yield put(getPosition({ idHotel }, token));
//             // yield put(getUser());
//         } else
//             if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }
//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* housekeepingManagementDeletePosition({ payload, token }) {
//     const { items } = payload;
//     try {
//         const dataRes = yield settingDeletePosition(items, token);
//         if (dataRes.status === 'success') yield put(getPosition({ spa_id: payload.spa_id }, token));
//         else
//             if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             }
//             else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
//                 yield PullNotificationManager("RoleCategory is used.");
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         console.log('error', error)
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* housekeepingManagementLoadStaff({ payload, token }) {
//     try {
//         const dataRes = yield settingGetStaff(payload, token);
//         if (dataRes.status === 'success') {
//             const dataFilter = dataRes.data.filter(el => el.name_position === "Owner")
//             const allDataFilter = dataRes.data.filter(el => el.name_position !== "Owner")
//             const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
//             const list = checkDataFilter.map(item => (
//                 {
//                     ...item,
//                     label: `${item.first_name} ${item.last_name}`,
//                     value: item.id_staff,
//                 }
//             ));
//             yield put(getStaffSuccess(checkDataFilter, list));
//         } else
//             if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     } catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* housekeepingManagementAddStaff({ payload, token }) {
//     try {
//         const dataRes = yield settingCreateStaff(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getStaff({ spa_id: payload.spa_id }, token));
//         } else
//             if
//                 (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }

//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             }
//             else {
//                 yield PullNotificationManager(`${dataRes.msg}`);
//             }

//     } catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* housekeepingManagementUpdateStaff({ payload, token }) {
//     try {
//         const dataRes = yield settingUpdateStaff(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getStaff({ spa_id: payload.spa_id }, token));
//             // yield put(getPosition({ idHotel }, token));
//             // yield put(getUser());
//         } else
//             if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }
//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* housekeepingManagementDeleteStaff({ payload, token }) {
//     // const { items } = payload;
//     try {
//         const dataRes = yield settingDeleteStaff(payload, token);
//         if (dataRes.status === 'success') yield put(getStaff({ spa_id: payload.spa_id }, token));
//         else
//             if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             }
//             else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
//                 yield PullNotificationManager("RoleCategory is used.");
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         console.log('error', error)
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// END Housekeeping Management

// Housekeeping Management
export function* watchLoadHousekeepingByTime() {
    yield takeEvery(
        HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_BY_DATE,
        housekeepingManagementLoadHousekeepingByTime
    );
}
export function* watchAddHousekeeping() {
    yield takeEvery(
        HOUSEKEEPING_MANAGEMENT_CREATE_HOUSEKEEPING,
        housekeepingManagementAddHousekeeping
    );
}
export function* watchUpdateHousekeeping() {
    yield takeEvery(
        HOUSEKEEPING_MANAGEMENT_UPDATE_HOUSEKEEPING,
        housekeepingManagementUpdateHousekeeping
    );
}
export function* watchDeleteHousekeeping() {
    yield takeEvery(
        HOUSEKEEPING_MANAGEMENT_DELETE_HOUSEKEEPING,
        housekeepingManagementDeleteHousekeeping
    );
}

// export function* watchLoadPosition() {
//     yield takeEvery(
//         HOUSEKEEPING_MANAGEMENT_LOAD_POSITION,
//         housekeepingManagementLoadPosition
//     );
// }
// export function* watchAddPosition() {
//     yield takeEvery(
//         HOUSEKEEPING_MANAGEMENT_CREATE_POSITION,
//         housekeepingManagementAddPosition
//     );
// }
// export function* watchUpdatePosition() {
//     yield takeEvery(
//         HOUSEKEEPING_MANAGEMENT_UPDATE_POSITION,
//         housekeepingManagementUpdatePosition
//     );
// }
// export function* watchDeletePosition() {
//     yield takeEvery(
//         HOUSEKEEPING_MANAGEMENT_DELETE_POSITION,
//         housekeepingManagementDeletePosition
//     );
// }

// export function* watchLoadStaff() {
//     yield takeEvery(
//         HOUSEKEEPING_MANAGEMENT_LOAD_STAFF,
//         housekeepingManagementLoadStaff
//     );
// }
// export function* watchAddStaff() {
//     yield takeEvery(
//         HOUSEKEEPING_MANAGEMENT_CREATE_STAFF,
//         housekeepingManagementAddStaff
//     );
// }
// export function* watchUpdateStaff() {
//     yield takeEvery(
//         HOUSEKEEPING_MANAGEMENT_UPDATE_STAFF,
//         housekeepingManagementUpdateStaff
//     );
// }
// export function* watchDeleteStaff() {
//     yield takeEvery(
//         HOUSEKEEPING_MANAGEMENT_DELETE_STAFF,
//         housekeepingManagementDeleteStaff
//     );
// }
// END Housekeeping Management

export default function* rootSaga() {
    yield all([
        //  Housekeeping Management
        fork(watchLoadHousekeepingByTime),
        fork(watchAddHousekeeping),
        fork(watchUpdateHousekeeping),
        fork(watchDeleteHousekeeping),

        // fork(watchLoadPosition),
        // fork(watchAddPosition),
        // fork(watchUpdatePosition),
        // fork(watchDeletePosition),

        // fork(watchLoadStaff),
        // fork(watchAddStaff),
        // fork(watchUpdateStaff),
        // fork(watchDeleteStaff),
    ])
}